'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { RatingIconsWithInfoFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingIconsWithInfoFragmentFragmentDoc';
import { CustomerRatingIconsWithReviewCount } from '../CustomerRatings/CustomerRatingIconsWithReviewCount/CustomerRatingIconsWithReviewCount';
import { CustomerReviewsInfoCallToAction } from '../CustomerReviews/CustomerReviewsInfoCallToAction/CustomerReviewsInfoCallToAction';

/* GraphQL */ `
  fragment RatingIconsWithInfoFragment on RatingProduct {
    avgRating
    reviewCount
  }
`;

export type RatingIconsWithInfoProps = {
  data: FragmentType<typeof RatingIconsWithInfoFragmentFragmentDoc>;
};

/**
 * RatingIconsWithInfo component shows the customer rating icons, the amount of given ratings and an information-icon which opens a Dialog with more information about customer ratings
 * */
export const RatingIconsWithInfo = ({ data, ...props }: RatingIconsWithInfoProps) => {
  const { avgRating, reviewCount } = getFragmentData(RatingIconsWithInfoFragmentFragmentDoc, data);

  const handleScroll = () => {
    document
      .getElementById('customer-ratings')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <div className="flex flex-row items-center" {...props}>
      <div
        onClick={handleScroll}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            handleScroll();
          }
        }}
        tabIndex={0}
        role="button"
        className="cursor-pointer"
      >
        <CustomerRatingIconsWithReviewCount ratingValue={avgRating} ratingsCount={reviewCount} />
      </div>
      <CustomerReviewsInfoCallToAction />
    </div>
  );
};
